import Close from '@mui/icons-material/Close'
import { useFormContext } from 'react-hook-form'
import { Button, IconButton } from '..'

type ResetFiltersProps = {
  onClick: () => void
}

export const ResetFilters = ({ onClick }: ResetFiltersProps) => {
  const { reset } = useFormContext()

  return (
    <>
      <Button
        sx={{ display: { md: 'flex', sm: 'none', xs: 'none' } }}
        variant="text"
        color="error"
        startIcon={<Close sx={{ color: '#D32F2F' }} />}
        onClick={() => {
          onClick?.()
          reset()
        }}
        style={{ minWidth: 100, color: '#D32F2F', marginRight: '10px' }}
        size="small"
      >
        Limpar
      </Button>
      <IconButton
        sx={{ display: { md: 'none' } }}
        onClick={() => {
          reset()
          onClick?.()
        }}
      >
        <Close sx={{ color: '#d32f2f' }} />
      </IconButton>
    </>
  )
}
